//GeneratorFlag:[NoChange]
import Activity from './activity';
import StaticFile from './static-file';

export default {Activity, StaticFile}
export{Activity, StaticFile}